// extracted by mini-css-extract-plugin
export default {"newNotificationsCount":"ProfileNotificationsPage_newNotificationsCount__WRrG+"};